import axiosGraphQL from './GraphQL/axiosGraphQL';
import { RewardInfoQuerys } from './GraphQL/Queries/RewardInfoQuerys';
import {
  ICreateNewUserReward,
  IGetCbxEmployee,
  IGetRewardInfo,
  IUpdateUserRewardById,
  RewardInfoVariables,
} from './GraphQL/Variables/RewardInfoVariables';

export const RewardInfoApis = {
  getRewardInfo: async (params: IGetRewardInfo): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.GET_REWARD_INFO,
      variables: RewardInfoVariables.getRewardInfo(params),
    });
  },
  saveRewardInfo: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.SAVE_REWARD_INFO,
      variables: RewardInfoVariables.saveRewardInfo(params),
    });
  },
  getCbxRewardCode: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.GET_CBX_REWARD_CODE,
      variables: RewardInfoVariables.getCbxRewardCode({}),
    });
  },
  getCbxUnit: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.GET_CBX_UNIT,
      variables: RewardInfoVariables.getCbxUnit({}),
    });
  },
  getCbxPosition: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.GET_CBX_POSITION,
      variables: RewardInfoVariables.getCbxPosition({}),
    });
  },
  getCbxEmployee: async (params: IGetCbxEmployee) => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.GET_CBX_EMPLOYEE,
      variables: RewardInfoVariables.getCbxEmployee(params),
    });
  },
  getCbxObject: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.GET_CBX_OBJECT,
      variables: RewardInfoVariables.getCbxObject({}),
    });
  },
  getCbxGroup: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.GET_CBX_GROUP,
      variables: RewardInfoVariables.getCbxGroup({}),
    });
  },
  getCbxStatus: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.GET_CBX_STATUS,
      variables: RewardInfoVariables.getCbxStatus({}),
    });
  },
  createNewUserReward: async (input: ICreateNewUserReward) => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.CREATE_NEW_USER_REWARD,
      variables: RewardInfoVariables.createNewUserReward(input),
    });
  },
  updateUserRewardById: async (input: IUpdateUserRewardById) => {
    return await axiosGraphQL.post('/graphql', {
      query: RewardInfoQuerys.UPDATE_USER_REWARD_BY_ID,
      variables: RewardInfoVariables.updateUserRewardById(input),
    });
  },
};
